module.exports = __webpack_public_path__ + "img/all_events_NEW.79ab7c7e.jpg";